import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { getConfigId } from "../../../../../../store/actions/devices/getConfig";
import CollapseGrid from "../../../../../UI/GeneralPurpose/CollapseGrid";
import { validateSelectionPassword } from "../../Actions/validateSelectionPassword";
import { selectionBlockUI } from "../../RemoteSelection";
import PassField, { passFieldId } from "./PassField";
import Submit from "./Submit";

const Blocked = () => {
  const { dispatch, settings, UI, warehouse } = useUIBp();
  const { value: password } = UI[passFieldId] ?? {};
  const blocked = UI[selectionBlockUI] ?? false;
  const { cpassword = "" } = warehouse[getConfigId] ?? {};
  const locale = settings.locale;

  const onSubmit = () => {
    dispatch(validateSelectionPassword({ password, cpassword, locale }));
  };

  return (
    <CollapseGrid open={blocked} outerProps={{ size: 12 }}>
      <PassField {...{ onSubmit }} />
      <Submit {...{ onSubmit }} />
    </CollapseGrid>
  );
};

export default Blocked;
